import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconMultiLineDept",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.147 1.147a.5.5 0 0 1 .707 0l1.5 1.5a.5.5 0 0 1 0 .707l-1.5 1.5a.5.5 0 0 1-.707-.707l.646-.647H6a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.793l-.646-.646a.5.5 0 0 1 .707-.707l1.5 1.5a.5.5 0 0 1 0 .707l-1.5 1.5a.5.5 0 1 1-.707-.707l.646-.647H6A1.5 1.5 0 0 1 4.5 8V6.5h-3a.5.5 0 0 1 0-1h3V4A1.5 1.5 0 0 1 6 2.5h2.793l-.646-.646a.5.5 0 0 1 0-.707Z",
  "clip-rule": "evenodd"
}, null, -1), u = [
  _
];
function m(a, h, i, p, f, e) {
  return r(), l("svg", {
    "aria-label": i.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--multi-line-dept"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Multi Line Dept",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, u, 10, c);
}
const I = /* @__PURE__ */ o(s, [["render", m]]);
export {
  I as default
};
//# sourceMappingURL=multi-line-dept.js.map
